import { NgModule } from '@angular/core';
import { CognitoAuthService } from './services/cognito-auth.service';
import { LegacyAuthService } from './services/legacy-auth.service';
import { ReflauntAuthService } from './services/reflaunt-auth.service';
import { AuthApiService } from './services/auth-api.service';
import {HttpClientModule} from "@angular/common/http";

@NgModule({
  imports: [HttpClientModule],
  providers: [CognitoAuthService, LegacyAuthService, ReflauntAuthService, AuthApiService],
  declarations: []
})
export class ReflauntAuthModule {}
